<div role="note" class="rounded-xl border-[1.5px] border-dashed border-foreground/30 bg-muted p-5">
    <span class="mb-3 inline-flex items-center gap-1.5 rounded-full border border-border bg-card px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-[0.07em] text-muted-foreground">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M8.3 10a.7.7 0 0 1-.626-1.079L11.4 3a.7.7 0 0 1 1.198-.043L16.3 8.9a.7.7 0 0 1-.572 1.1Z" />
            <rect x="3" y="14" width="7" height="7" rx="1" />
            <circle cx="17.5" cy="17.5" r="3.5" />
        </svg>
        {{ tagLabel() }}
    </span>

    <div class="flex flex-col gap-[9px]" aria-hidden="true">
        @for (width of lineWidths(); track $index) {
        <i class="block h-[11px] rounded-[5px] bg-muted-foreground/15" [style.width.%]="width"></i>
        }
    </div>

    <p class="mt-3 max-w-[70ch] text-[12.5px] leading-relaxed text-muted-foreground">{{ caption() }}</p>
</div>
